import { TruckSizeUnion } from '../../../../../../common/constants/truck-size';
import { UliActivityType, UliOrigin } from '../../../../../../common/constants/uli';
import { AllocationViewNextActionModel, AllocationViewRuleModel } from '../../models';
import { AllocationViewTruckActionModel } from '../../models/allocation-view-truck-action-model';

export class UliBriefModel {
  actions: AllocationViewNextActionModel[];
  carrierExtId: string;
  carrierName: string;
  carrierNumber: string;
  freeTextCarrierName: string;
  allocatedCompartmentId: number;
  allocatedCompartmentName: string;
  compartmentId: number;
  compartmentName: string;
  dockId: number;
  dockName: string;
  erpConfirmationPending: boolean;
  hubId: number;
  hubName: string;
  loadNumber: string;
  origin: UliOrigin;
  region: string;
  trailerPlate: string;
  trailerPlateCountry: string;
  truckActions: AllocationViewTruckActionModel[];
  truckId: number;
  truckPlate: string;
  truckPlateCountry: string;
  truckSize: TruckSizeUnion;
  truckStatus: string;
  slotId: number;
  type: UliActivityType;
  uli: string;
  uliStatus: string;
  ruleInfo?: AllocationViewRuleModel;
  equipmentTypes: string[];
}
